import { useEffect, useState } from 'react';
import { useFetch } from './useFetch';
import { env } from '../config'

export const analyzeTextResultTypes = {
    match: "Match",
    suggestions: "Suggestions",
};

export const useAnalyzeText = (text) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const { loading: fetchLoading, error, data: fetchData, post, clean } = useFetch(`${env.REACT_APP_BASS_RAVMILIM_API_URL()}/AnalyzeText`);

    useEffect(() => {
        if (text) {
            post({ text });
        }
        else {
            clean();
        }
    }, [text, post, clean]);

    useEffect(() => {
        let isActive = true;

        if (!fetchLoading) {
            setTimeout(() => {
                if (isActive) {
                    setLoading(false);
                }
            }, 500);
        }
        else {
            setLoading(true);
        }

        return () => {
            isActive = false;
        };
    }, [fetchLoading]);


    useEffect(() => {
        if (fetchData) {
            fetchData.words = (fetchData.words || []).map((w, i) => {
                if (w.id == null && w.inputWordEntry != null) {
                    w.id = encodeURIComponent(`t_${w.inputWordEntry}_${w.partOfSpeech}_${w.translation}`);
                    w.type = 'en'
                }
                else if (w.id == null && w.explain != null) {
                    w.id = encodeURIComponent(`n_${w.explain}`);
                    w.type = 'num'
                }
                else
                    w.type = 'word'
                return w;
            });

        }
        setData(fetchData);


    }, [fetchData]);

    return {
        loading,
        error,
        data,
    };
};